import { CountryConfigType } from '../../model/CountryConfigType'

const config: CountryConfigType = {
  showQuoteSummaryAgreementNotice: true,
  showLanguageSelector: true,
  skipInitialRules: true,
}

export default config
